import React from 'react';
export function EditorAlignCenterIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M18 5H6v2h12V5zm4 4H2v2h20V9zM6 13h12v2H6v-2zm16 4H2v2h20v-2z"
  }));
}